import request from './axios.config'

/**
 * 获取租户信息
 * post
 * **/
export const getTenantInfo = (data) => {
    return request({
        url: `/npgw/local/cms/getTenantJsonInfo`,
        method: 'POST',
        data
    })
}

/**
 * 获取产品菜单
 * post
 * **/
export const listProductMenuByProductCodeAndUserCode = (params) => {
    return request({
        url: `/npgw/common-layer/userMenuPermission/listProductMenuByProductCodeAndUserCode`,
        method: 'get',
        params
    })
}

/**
 * 获取网站级菜单
 * @param {{tenantId: string, instance: string, userCode: string, isSuper: number}} params 
 */
export const listTenantMenuByUserCodeAndTenantId =  (params) => {
    return request({
        url: `/npgw/common-layer/userMenuPermission/listTenantMenuByUserCodeAndTenantId`,
        method: 'get',
        params
    })
}

/**
 * 获取token
 * get
 * **/

// pwa环境实现7天免密 更换token接口
const isInStandaloneMode = () =>
    (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

export function getToken() {
    return request({
        url: isInStandaloneMode() ? '/npgw/local/current/pwa/usertoken' : '/npgw/local/current/usertoken',
        method: 'get',
    });
}
/**
 * 获取租户信息
 * get
 * **/
export function getLoginUser() {
    return request({
        url: '/npgw/local/cms/getLoginUser',
        method: 'get',
    });
}

/*
***
获取集团子站列表
*/

export function listGroupSubInfo(groupId) {
    return request({
        url: `/npgw/common-layer/userTenantPermission/listGroupSubInfo/${groupId}`,
        method: 'get',
    });
}

/**
 * 获取网站级菜单
 * @param {{tenantId: string, instance: string}} params 
 */

export function searchList(params) {
    return request({
        url: `/npgw/searchnav/tag/help/ce`,
        params,
        method: 'get',
    });
}

/**
 * 判断是否创建默认应用，是：返回已创建的应用数据；否：创建默认应用并且自动订阅通用API，返回已创建的应用数据
 * @param {{appCreater: string, custId: string, instanceCode: string}} data post 
 */
export const getOpenInfo = (data) => {
    return request({
        baseURL: 'https://test-developer.platopen.com',
        url: `/dev-center-server/openapi/szmh/save`,
        method: 'POST',
        data,
        delPublicParams: true // 不带公有参数
    })
}
/**
 * 获取质检报告
 * @param {*} params 
 * @returns 
 */
export function siteReport(params) {
    return request({
        url: `/npgw/mwebapi/sop/service-order/interface/api/query/site/report`,
        params,
        method: 'get',
    });
}

/**
获取当前菜单的帮助链接
 */
export const getCurMenuHelp = (params) => {
    return request({
        url: `/npgw/common-layer/menuHelpLink/getOneBy`,
        method: 'get',
        params
    })
}
